import { StyleSheet, Platform } from "react-native";
import { createDrawerNavigator } from "@react-navigation/drawer";
import { createNativeStackNavigator } from "@react-navigation/native-stack";

//import SettingsScreen from "../screens/settingsscreen";
import CustomDrawer from "../components/CustomDrawer";
import SensorStack from "./SensorStack";
import ServiceStack from "./ServiceStack";
import SettingScreen from "../screens/settingscreen";
import ImpressumScreen from "../screens/impressumscreen";

//import Ionicons from "react-native-vector-icons/Ionicons";
import { Ionicons } from "../components/VectorIcons";
import LogScreen from "../screens/logscreen";
import React from "react";
import ChangePasswordStack from "../screens/changepasswordscreen";
import MeasuringPointStack from "./MeasuringPointStack";
import { AuthContext } from "../context/AuthContext";
import { pageTitle, getSchemeStyle } from "../context/helper";
import RequestFormStack from "./RequestFormStack";
import { showProtokoll, showRequest } from "../config";

const Drawer = createDrawerNavigator();

const DrawerStack = () => {
  const schemeStyles = getSchemeStyle();

  const { userInfo } = React.useContext(AuthContext);

  return (
    <Drawer.Navigator
      drawerContent={(props) => <CustomDrawer {...props} />}
      screenOptions={{
        headerShown: false,
        drawerLabelStyle: styles.drawerLabel,
        drawerActiveBackgroundColor: schemeStyles.Drawer.activeBackgroundColor,
        drawerActiveTintColor: schemeStyles.Drawer.activeTintColor,
        drawerInactiveTintColor: schemeStyles.Drawer.inactiveTintColor,
      }}
    >
      <Drawer.Screen
        component={SensorStack}
        name="Übersicht"
        options={{
          drawerIcon: ({ color }) => (
            <Ionicons name="home-outline" size={22} color={color} />
          ),
        }}
      />
      {(userInfo.current.R_Admin || userInfo.current.R_FirmAdmin) && (
        <Drawer.Screen
          component={MeasuringPointStack}
          name="Messstellen"
          options={{
            drawerIcon: ({ color }) => (
              <Ionicons name="thermometer-outline" size={22} color={color} />
            ),
          }}
        />
      )}
      {showProtokoll && (
        <Drawer.Screen
          component={LogScreen}
          name="Protokoll"
          options={{
            drawerIcon: ({ color }) => (
              <Ionicons name="reader-outline" size={22} color={color} />
            ),
            title: pageTitle("Protokoll"),
          }}
        />
      )}
      {Platform.OS === "android" && (
        <Drawer.Screen
          component={SettingScreen}
          name="Einstellungen"
          options={{
            drawerIcon: ({ color }) => (
              <Ionicons name="settings-outline" size={22} color={color} />
            ),
            title: pageTitle("Einstellungen"),
          }}
        />
      )}
      <Drawer.Screen
        component={ImpressumScreen}
        name="Impressum"
        options={{
          drawerItemStyle: {},
          drawerIcon: ({ color }) => (
            <Ionicons name="finger-print-outline" size={22} color={color} />
          ),
        }}
      />
      {showRequest &&
      <Drawer.Screen
        component={RequestFormStack}
        name="Antrag"
        options={{
          drawerItemStyle: {},
          drawerIcon: ({ color }) => (
            <Ionicons name="document-text-outline" size={22} color={color} />
          ),
        }}
      />}
    </Drawer.Navigator>
  );
};

const Stack = createNativeStackNavigator();
const AppStack = () => {
  const { isService } = React.useContext(AuthContext);

  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      {isService ? (
        <Stack.Screen component={ServiceStack} name="ServiceStack" />
      ) : (
        <>
          <Stack.Screen component={DrawerStack} name="DrawerStack" />
          <Stack.Screen
            component={ChangePasswordStack}
            name="ChangePassword2"
          />
        </>
      )}
    </Stack.Navigator>
  );
};

export default AppStack;

const styles = StyleSheet.create({
  drawerLabel: {
    marginLeft: -25,
    fontFamily: "Roboto-Medium",
    fontSize: 15,
  },
});
